import { environment } from '../../environments/environment';
import { Portal } from './portal';

export const PORTALS: readonly Portal[] = [
  {
    id: 'admin',
    name: 'Admin',
    tagline: 'Control, permisos y configuración',
    url: environment.portal2_url,
    accent: '#7c5cff',
  },
  {
    id: 'dashboard',
    name: 'Dashboard',
    tagline: 'Métricas e indicadores en tiempo real',
    url: environment.portal4_url,
    accent: '#0ea5c4',
  },
  {
    id: 'operadores',
    name: 'Operadores',
    tagline: 'Gestión y seguimiento de personal',
    url: environment.portal1_url,
    accent: '#f59e0b',
  },
  {
    id: 'proveedores',
    name: 'Proveedores',
    tagline: 'Catálogo, pedidos y abastecimiento',
    url: environment.portal3_url,
    accent: '#10b981',
  },
];
